<ng-container *transloco="let t">
  <article
    class="product-card popsy-card"
    [class.mobile]="(biggerThan$ | async)?.xs"
    [class.mobileL]="(biggerThan$ | async)?.mobileL"
    [class.widescreen]="(biggerThan$ | async)?.sm">
    <app-product-json-ld [product]="product"></app-product-json-ld>

    <!-- badges -->
    @if (showFlags && (biggerThan$ | async)?.xs) {
      <div class="badges-cont">
        @if (product?.isFeatured === true || bestSeller) {
          <div
            [class.rtl]="isRtl$ | async"
            class="flex align-center justify-center badge">
            {{ t('label_best_seller') }}
          </div>
        }
        <span class="dynamic-space" aria-hidden="true"></span>
        @if (hasDiscount) {
          <app-featured-discount-badge
            [price]="product?.price?.amount"
            [originalPrice]="product?.originalPrice?.amount"
            [flagMode]="true"></app-featured-discount-badge>
        }
      </div>
    }

    <a
      class="phone-link"
      [routerLink]="urlFragment$ | async"
      [queryParams]="productParams$ | async"
      [attr.aria-label]="
        product?.model || product?.title || t('title_activity_listing_settings')
      ">
      @if (bestSeller) {
        <span class="fixed-space-16" aria-hidden="true"></span>
      }
      <span
        class="pic-wrapper flex"
        [class.best-seller]="bestSeller"
        [class.wide-wrapper]="bestSeller">
        @if (!product) {
          <popsy-skeleton class="picture skeleton"></popsy-skeleton>
        }
        @if (product && !isBrowser) {
          <img
            class="picture"
            [src]="(product?.images || [])[0]"
            [alt]="product?.title"
            [title]="product?.title" />
        }
        @if (product && isBrowser) {
          <app-picture
            class="picture"
            [alt]="product?.title"
            [pictureUrl]="(product?.images || [])[0]"></app-picture>
        }
      </span>
      <span class="fixed-space-8" aria-hidden="true"></span>
    </a>
    <span class="fixed-space-8" aria-hidden="true"></span>
    <nav class="elem-wrapper text-gray-05 full-height full-width">
      <a
        class="phone-link"
        [routerLink]="urlFragment$ | async"
        [queryParams]="productParams$ | async"
        [attr.aria-label]="
          product?.model || product?.title || t('title_activity_listing_settings')
        ">
        <span class="elem-wrapper text-gray-05 full-width">
          <div class="flex flex-mobile justify-between align-base">
            @if (!product) {
              <popsy-skeleton class="title skeleton"></popsy-skeleton>
            }
            @if (product) {
              <h4 [class.wide-title]="product?.category === 'LAPTOP'">
                {{ product?.title || product?.model || '' }}
              </h4>
            }
          </div>
        </span>
      </a>

      <span class="dynamic-space" aria-hidden="true"></span>

      @if (product) {
        <span class="badges-wrap">
          <!-- GET ALL COLOR VARIANTS -->
          <ng-container>
            <app-product-color-variants
              [id]="product.id"
              [model]="product.model"
              [switchMode]="true"
              (switchProductID)="onSwitchProductID($event)"
              displayMode="small"></app-product-color-variants>
          </ng-container>
          @if (!product) {
            <popsy-skeleton class="badge skeleton"></popsy-skeleton>
            <span aria-hidden="true" class="fixed-space-8"></span>
            <popsy-skeleton class="badge skeleton"></popsy-skeleton>
          }
        </span>
      }
      <span aria-hidden="true" class="fixed-space-8"></span>
      <!-- Price -->
      <span
        class="flex flex-mobile justify-between align-base"
        [class.force-col]="bestSeller">
        @if (hasDiscount && !bestSeller) {
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="small crossed"> {{ product?.originalPrice | amount }} </span>
        }

        @if ((biggerThan$ | async)?.xs && !bestSeller) {
          <span class="fixed-space-16" aria-hidden="true"></span>
        }

        <h4 class="text-highlight">{{ product?.price | amount }}</h4>
      </span>
      <span class="fixed-space-16" aria-hidden="true"></span>

      @if (!bestSeller) {
        <app-featured-buy-buttons
          class="full-width"
          [product]="product"></app-featured-buy-buttons>
      }
    </nav>
  </article>
</ng-container>
